import { z } from "zod";

// Start node schema
export const startNodeSchema = z.object({
  title: z
    .string()
    .min(1, "Title is required")
    .max(45, "Title should be precise and less than 45 characters")
    .regex(
      /^[a-zA-Z0-9_ -]*$/,
      "Name can only contain alphanumeric characters, `-` and `_`",
    ),
  description: z.string().min(1, "Description is required"),
  isValid: z.boolean().default(true),
});

export type StartNodeSchema = z.infer<typeof startNodeSchema>;

export const defaultStartNodeValues: StartNodeSchema = {
  title: "",
  description: "",
  isValid: true,
};
